export const PrimaryMobile = (props) => {
  return (
    <button
      disabled={props?.disabled}
      type={props.onClick ? "button" : "submit"}
      onClick={props.onClick}
      className={`flex justify-center p-2 rounded-full shadow-xs text-md font-medium text-white ${props?.disabled ? "bg-tgray" : "bg-purple hover:bg-purpleDark" } transition duration-300  focus:outline-hidden`}
      style={{cursor: "pointer"}}
    >
      <div className="flex gap-2">
        {props.text ?
          <div className="px-4">{props.text}</div> :
          <></>
        }
        {props.icon}
      </div>
    </button>
  );
};
